module.exports = __webpack_public_path__ + "img/1573471245.2d5314cc.jpg";